export const VALIDATE_VAT_NUMBER = gql`
    mutation validateVATNumber($vatNumber: String!) {
        validateVATNumber(vatNumber: $vatNumber)
    }
`;
